import { IEnvironment } from '@env/environment.model';

export const environment: IEnvironment = {
  production: true,
  legacy_api_server_url: 'https://developers.lightmetrics.co',
  intermediate_server_url: 'https://white-v2.lightmetrics.co',
  redirect_url: '',
  callbackURL: 'https://uae-cabvision.machinemax.com/callback',
  scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
  cognitoConfigs: {
    'ap-south-1': {
      clientID: '6vjog24scia44in5omdr96emos',
      domain: 'https://fleet-dashboard.auth.us-east-1.amazoncognito.com',
    },
  },
  env: 'prod',
};
